import { render, staticRenderFns } from "./Materia.vue?vue&type=template&id=04fead73&"
import script from "./Materia.vue?vue&type=script&lang=js&"
export * from "./Materia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports